import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import MultipleGoogleMediaUpload from '../../GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'
import ImageAssetPreview from '../../GoogleAssetsSliderPreview/Previews/ImageAssetPreview'

import { lightGrey } from '../../../../../styles/const/colors'

import { FILE_URL, LANDSCAPE_LOGO, landscapeLogoHeight, landscapeLogoWidth } from '../../fields'
import { landscapeLogoValidationSchema } from '../../validations'

import useCommonStyles from '../../../../../styles/common/stepForms'
import useStyles from './styles'

const stepFields = [LANDSCAPE_LOGO]
function LandscapeLogoStep({ formik, handleStepChange, isStepFieldsValid }) {
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const { t } = useTranslation()

  const { values } = formik

  const fileUrl = values[LANDSCAPE_LOGO][0]?.[FILE_URL]

  const handleContinue = () => {
    handleStepChange(stepFields, values)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Upload a landscape logo with ratio 4:1')}</div>
      <div className={commonClasses.stepBody}>
        <div className={classes.landscapeLogo}>
          <ImageAssetPreview
            containerWidth={260}
            width={landscapeLogoWidth}
            height={landscapeLogoHeight}
            fileUrl={fileUrl}
            backgroundColor={'white'}
            arrowColor={lightGrey}
          />
        </div>
        <MultipleGoogleMediaUpload
          formik={formik}
          FileItemPath={LANDSCAPE_LOGO}
          validationSchema={landscapeLogoValidationSchema}
          isStepFieldsValid={isStepFieldsValid}
          addAnotherButtonText={'Add another landscape logo'}
          width={landscapeLogoWidth}
          height={landscapeLogoHeight}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default LandscapeLogoStep
